<template>
    <div class="tips-box">
        <div class="hd">
            <i class="el-icon-success text-primary" />
        </div>
        <div class="bd">
            新密码设置成功
        </div>
        <div class="ft">
            现在您可以使用新密码登录金穗智管
        </div>
        <div class="extra">
            <el-button
                type="primary"
                class="btn-standard"
                @click="goPage(`/login`)"
            >
                立即登录
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Step3',
    inject: ['goPage']
}
</script>

<style scoped lang="scss">
    .tips-box {
        text-align: center;
        margin-top: 50px;
        .hd {
            font-size: 48px;
            margin-bottom: 20px;
        }
        .bd {
            font-size: 24px;
            margin-bottom: 10px;
        }
        .extra {
            margin-top: 30px;
        }
    }
</style>
